export const mockCardPrograms = [
    {
        PCardId: 1,
        CardProgramName: 'Corporate Travel Card',
        CardNumberLastFour: '1234',
        CardEarliestExpenseDate: new Date('2020-01-01'),
        CardLatestExpenseDate: new Date('2024-12-31')
    },
    {
        PCardId: 2,
        CardProgramName: 'Business Expense Card',
        CardNumberLastFour: '5678',
        CardEarliestExpenseDate: new Date('2011-01-01'),
        CardLatestExpenseDate: new Date('2023-12-31')
    },
    {
        PCardId: 3,
        CardProgramName: 'Executive Card',
        CardNumberLastFour: '9012',
        CardEarliestExpenseDate: new Date('2000-01-01'),
        CardLatestExpenseDate: new Date('2005-12-31')
    }
];
